module.exports = require("./crossfilter").crossfilter;



/*****************
 ** WEBPACK FOOTER
 ** ../~/crossfilter/index.js
 ** module id = 85
 ** module chunks = 0
 **/